import { render, staticRenderFns } from "./threeSite.vue?vue&type=template&id=89622c70&scoped=true&"
import script from "./threeSite.vue?vue&type=script&lang=js&"
export * from "./threeSite.vue?vue&type=script&lang=js&"
import style0 from "./threeSite.vue?vue&type=style&index=0&id=89622c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89622c70",
  null
  
)

export default component.exports